{
  "common": {
    "ok": "OK",
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "loading": "Cargando...",
    "error": "Error",
    "info": "Información",
    "success": "Éxito",
    "back": "Volver",
    "send": "Enviar",
    "sending": "Enviando...",
    "search": "Buscar",
    "accept": "Aceptar",
    "reject": "Rechazar",
    "confirm": "Confirmar",
    "online": "En línea",
    "you": "Tú",
    "noMessages": "Sin mensajes todavía",
    "adminPanelDesktopOnly": "Panel no disponible en móvil",
    "adminPanelDesktopOnlyHint": "El panel de administración y organizador está disponible en tablet y escritorio.",
    "networkError": "No hemos podido cargar los datos.",
    "networkErrorHint": "Comprueba tu conexión e inténtalo de nuevo.",
    "retry": "Reintentar",
    "myQrCode": "Mi código QR",
    "myQrPill": "Mi QR",
    "hideQrPill": "Ocultar Mi QR",
    "showQrPill": "Mostrar Mi QR",
    "today": "Hoy",
    "tomorrow": "Mañana"
  },
  "auth": {
    "login": {
      "title": "¡Bienvenido de vuelta!",
      "subtitle": "Iniciar Sesión",
      "credentialsHint": "Introduce tus credenciales para continuar",
      "email": "Correo Electrónico",
      "emailPlaceholder": "tu@email.com",
      "password": "Contraseña",
      "passwordPlaceholder": "••••••••",
      "loading": "Iniciando sesión...",
      "button": "Iniciar Sesión",
      "forgotPassword": "¿Olvidaste tu contraseña?",
      "forgotPasswordSoon": "Próximamente",
      "forgotPasswordMessage": "La recuperación de contraseña estará disponible pronto.",
      "continueWith": "o continúa con",
      "noAccount": "¿No tienes cuenta?",
      "createAccount": "Crear cuenta",
      "errors": {
        "emailNotConfirmed": "No pudimos iniciar sesión.\n\nSi acabas de crear tu cuenta, vuelve a intentarlo en unos segundos.",
        "loginError": "Error al iniciar sesión",
        "unexpectedError": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo."
      }
    },
    "register": {
      "title": "¡Únete a BIAVENT!",
      "subtitle": "Crear Cuenta",
      "email": "Correo Electrónico",
      "emailPlaceholder": "tu@email.com",
      "password": "Contraseña",
      "confirmPassword": "Confirmar Contraseña",
      "loading": "Creando cuenta...",
      "button": "Crear Cuenta",
      "continueWith": "o continúa con",
      "hasAccount": "¿Ya tienes cuenta?",
      "loginLink": "Iniciar sesión",
      "success": {
        "title": "✅ ¡Cuenta creada con éxito!",
        "message": "Ya puedes entrar. Vamos a completar tu perfil."
      },
      "errors": {
        "createError": "Error al crear cuenta",
        "unexpectedError": "Error inesperado"
      }
    },
    "logout": {
      "button": "Cerrar Sesión",
      "confirm": "¿Estás seguro de que quieres cerrar sesión?"
    },
    "forgotPassword": {
      "title": "Recuperar contraseña",
      "subtitle": "Restablece tu contraseña",
      "description": "Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
      "email": "Correo electrónico",
      "emailPlaceholder": "tu@email.com",
      "loading": "Enviando...",
      "button": "Enviar enlace",
      "backToLogin": "Volver a iniciar sesión",
      "success": {
        "title": "Revisa tu correo",
        "message": "Si existe una cuenta con ese email, recibirás un enlace para restablecer tu contraseña."
      },
      "errors": {
        "unexpectedError": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo."
      }
    },
    "resetPassword": {
      "title": "Nueva contraseña",
      "subtitle": "Elige una nueva contraseña",
      "description": "Introduce y confirma tu nueva contraseña.",
      "password": "Nueva contraseña",
      "passwordPlaceholder": "••••••••",
      "confirmPassword": "Confirmar contraseña",
      "confirmPasswordPlaceholder": "••••••••",
      "loading": "Actualizando...",
      "button": "Actualizar contraseña",
      "backToLogin": "Volver a iniciar sesión",
      "requirements": {
        "minLength": "Mínimo 8 caracteres",
        "lowercase": "Al menos una minúscula",
        "uppercase": "Al menos una mayúscula",
        "number": "Al menos un número",
        "symbol": "Al menos un símbolo"
      },
      "success": {
        "title": "Contraseña actualizada",
        "message": "Tu contraseña se ha actualizado correctamente."
      },
      "invalidLink": {
        "title": "Enlace inválido o expirado",
        "message": "Este enlace de recuperación no es válido o ha caducado. Solicita uno nuevo.",
        "cta": "Solicitar nuevo enlace"
      },
      "errors": {
        "unexpectedError": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo."
      }
    }
  },
  "onboarding": {
    "personalInfo": {
      "title": "Información Personal",
      "subtitle": "Completa tu perfil básico",
      "firstName": "Nombre",
      "lastName": "Apellidos",
      "phone": "Teléfono",
      "email": "Email",
      "placeholderFirstName": "Tu nombre",
      "placeholderLastName": "Tus apellidos",
      "placeholderPhone": "+34 600 000 000",
      "placeholderEmail": "tu@email.com",
      "continue": "Continuar",
      "errorFirstName": "El nombre es requerido",
      "errorLastName": "Los apellidos son requeridos",
      "errorPhone": "Por favor ingresa un teléfono válido",
      "errorEmail": "Por favor ingresa un email válido"
    },
    "socialNetworks": {
      "title": "Redes Sociales (Elige una o varias)",
      "linkedin": "LinkedIn",
      "instagram": "Instagram",
      "twitter": "X (Twitter)",
      "youtube": "YouTube",
      "tiktok": "TikTok",
      "placeholderLinkedin": "https://linkedin.com/in/tu-perfil",
      "placeholderInstagram": "https://instagram.com/tu-usuario",
      "placeholderTwitter": "https://twitter.com/tu-usuario",
      "placeholderYoutube": "https://youtube.com/@tu-canal",
      "placeholderTiktok": "https://tiktok.com/@tu-usuario",
      "errorInvalid": "Por favor ingresa una URL válida"
    },
    "welcomeQuestion": {
      "title": "¿A qué te dedicas?",
      "subtitle": "Tu respuesta nos ayudará a generar palabras clave de networking y a sugerirte conexiones relevantes dentro del evento.",
      "placeholder": "Ej: Soy desarrollador frontend, trabajo en marketing digital, soy emprendedor...",
      "continue": "Continuar",
      "back": "Atrás",
      "loading": "Procesando...",
      "error": "No pudimos procesar tu respuesta. Intenta de nuevo.",
      "errorEmpty": "Escribe algo sobre ti para continuar"
    }
  },
  "appTour": {
    "replayButton": "Ver tutorial de nuevo",
    "welcome": {
      "title": "¡Bienvenido a Biavent!",
      "subtitle": "Te mostramos en pocos pasos lo esencial para empezar.",
      "start": "Comenzar recorrido",
      "skip": "Omitir por ahora"
    },
    "controls": {
      "prev": "Anterior",
      "next": "Siguiente",
      "skip": "Omitir tutorial",
      "close": "Cerrar",
      "done": "Finalizar",
      "progress": "{{current}} de {{total}}",
      "tapHere": "Pulsa aquí"
    },
    "steps": {
      "navOverview": {
        "title": "Navegación",
        "body": "Desde aquí accedes a las secciones principales de la app."
      },
      "eventsHome": {
        "title": "Tus eventos",
        "body": "Aquí ves los próximos eventos y tu bienvenida personalizada."
      },
      "eventsDiscover": {
        "title": "Explora eventos",
        "body": "Aquí aparecen todos los eventos."
      },
      "navNetworking": {
        "title": "Networking",
        "body": "Pulsa aquí para ir a conexiones y chats."
      },
      "networkingHub": {
        "title": "Actividad y conexiones",
        "body": "Gestiona solicitudes, contactos y conversaciones."
      },
      "navProfile": {
        "title": "Tu perfil",
        "body": "Pulsa para ver y editar tu perfil profesional."
      },
      "profileComplete": {
        "title": "Perfil completo",
        "body": "Cuanto más completes tu perfil, mejores recomendaciones te podemos ofrecer."
      },
      "qrEssential": {
        "title": "Tu código QR",
        "body": "Muestra tu QR en eventos para conectar al instante."
      }
    }
  },
  "settings": {
    "title": "Ajustes",
    "subtitle": "Gestiona tus preferencias",
    "appearance": {
      "title": "Apariencia",
      "theme": {
        "label": "Tema",
        "auto": "Automático (como el dispositivo)",
        "light": "Claro",
        "dark": "Oscuro",
        "description": "Elige cómo quieres que se vea la aplicación"
      }
    },
    "language": {
      "title": "Idioma",
      "label": "Idioma",
      "auto": "Automático (según dispositivo)",
      "description": "Elige el idioma de la aplicación",
      "detected": "Detectado"
    },
    "appTour": {
      "title": "Tutorial de la app",
      "description": "Vuelve a ver el recorrido guiado por las funciones principales.",
      "replay": "Ver tutorial de nuevo"
    },
    "notifications": {
      "title": "Notificaciones",
      "subtitle": "Gestiona tus preferencias de notificaciones push"
    },
    "dataAndCache": {
      "title": "Datos y caché",
      "description": "Actualiza los datos en caché o recarga la aplicación para ver la información más reciente o solucionar problemas de carga.",
      "refreshData": "Actualizar datos",
      "clearAndReload": "Limpiar caché y recargar",
      "refreshSuccess": "Caché limpiada. Los nuevos datos se cargarán al navegar.",
      "reloading": "Recargando..."
    }
  },
  "events": {
    "title": "Eventos",
    "greeting": "Hola",
    "upcomingEvent": "evento próximo",
    "upcomingEvents": "eventos próximos",
    "noUpcoming": "No hay eventos próximos",
    "recommendationHint": "Para recibir recomendaciones personalizadas de asistentes, regístrate en los eventos que te interesen.",
    "recommendationHintShort": "Regístrate en eventos para recibir recomendaciones personalizadas.",
    "loading": "Cargando eventos...",
    "hidePast": "Ocultar eventos pasados",
    "showPast": "Ver eventos pasados",
    "noEvents": "No hay eventos",
    "noEventsMessage": "Por ahora no hay eventos programados. Vuelve pronto para descubrir nuevas oportunidades de conexión y aprendizaje.",
    "live": "EN VIVO",
    "registered": "Registrado",
    "full": "Completo",
    "register": "Registrarse",
    "sectionUpcoming": "Próximos eventos",
    "sectionPast": "Eventos pasados",
    "filterAll": "Todos",
    "filterRegistered": "Registrado",
    "filterPast": "Pasados",
    "upcomingBadge": "Próximo",
    "participants": {
      "zero": "0 participantes",
      "one": "1 participante",
      "many": "{count} participantes"
    },
    "capacity": {
      "full": "Completo ({max}/{max})",
      "oneLeft": "{current}/{max} plazas (1 disponible)",
      "available": "{current}/{max} plazas ({available} disponibles)"
    }
  },
  "eventDetail": {
    "loading": "Cargando evento...",
    "notFound": "Evento no encontrado",
    "backToEvents": "Volver a eventos",
    "back": "Volver",
    "live": "EN VIVO",
    "description": "Descripción",
    "readMore": "Leer más",
    "readLess": "Ver menos",
    "spotsRemaining": "{count} plazas restantes",
    "registration": {
      "title": "Inscripción",
      "subtitle": "Reserva tu plaza y recibe toda la información necesaria para participar.",
      "full": "Evento completo ({max}/{max} plazas)",
      "capacity": "{count}/{max} plazas ocupadas ({available} disponibles)",
      "limitedSeats": "Plazas limitadas: confirma tu asistencia para asegurar tu lugar.",
      "pastEvent": "Este evento ya se realizó, consulta el calendario para nuevos encuentros.",
      "alreadyRegistered": "Ya estás registrado y recibirás las novedades del evento.",
      "unregisterLoading": "Cancelando inscripción...",
      "unregister": "Desinscribirme del evento",
      "eventFull": "Este evento está completo. No hay plazas disponibles.",
      "registerLoading": "Guardando tu plaza...",
      "registerButton": "Inscribirme al evento",
      "checkingRegistration": "Verificando si ya estás registrado...",
      "loadingProfile": "Cargando tu perfil para habilitar la inscripción...",
      "registeredTitle": "¡Estás inscrito!",
      "registeredEmailHint": "Te enviaremos toda la información por email"
    },
    "registrationGoal": {
      "title": "¿Cuál es tu objetivo en este evento?",
      "subtitle": "Cuéntanos qué buscas en \"{eventTitle}\" para recomendarte personas con intereses alineados.",
      "placeholder": "Ej: Hacer networking con desarrolladores, buscar inversores, aprender sobre nuevas tecnologías...",
      "submit": "Inscribirme y calcular matches ✨",
      "error": "Por favor, escribe un objetivo para ayudarte a conectar mejor.",
      "tagsTitle": "Sugerencias rápidas (puedes elegir varias):",
      "saveObjective": "Guardar objetivo ✨",
      "profileSaveError": "No pudimos guardar tu objetivo. Inténtalo de nuevo.",
      "tag1": "🤝 Encontrar socios o colaboradores",
      "tag2": "💼 Buscar oportunidades de negocio",
      "tag3": "✨ Hacer networking y contactos",
      "tag4": "📚 Aprender y adquirir conocimientos",
      "tag5": "🚀 Conocer gente del sector"
    },
    "tabs": {
      "agenda": "Agenda",
      "speakers": "Ponentes",
      "recommendations": "Recomendaciones",
      "notifications": "Notificaciones",
      "location": "Ubicación"
    },
    "agenda": {
      "title": "Agenda",
      "noAgenda": "No hay agenda disponible para este evento."
    },
    "speakers": {
      "title": "Ponentes",
      "subtitle": "Conoce a los expertos que compartirán su conocimiento en este evento.",
      "confirmed": "speakers confirmados",
      "noSpeakers": "No hay ponentes registrados para este evento.",
      "learnMore": "Saber más",
      "bio": "Biografía",
      "experience": "Experiencia profesional",
      "careerPath": "Trayectoria",
      "additionalInfo": "Información adicional",
      "noDetails": "Este ponente aún no tiene información detallada."
    },
    "recommendations": {
      "recommended": "Recomendados",
      "allAttendees": "Todos los asistentes",
      "title": "Personas Recomendadas",
      "subtitle": "Personas inscritas en el evento que podrían interesarte.",
      "calculating": "Calculando recomendaciones...",
      "noRecommendations": "No hay recomendaciones disponibles en este momento.",
      "attendeesTitle": "Asistentes del evento",
      "attendeesSubtitle": "Personas que ya confirmaron su participación.",
      "loadingAttendees": "Cargando asistentes...",
      "beFirst": "Sé la primera persona en registrarse al evento.",
      "connect": "Conectar",
      "requestSent": "Solicitud enviada",
      "openChat": "Abrir chat"
    },
    "notifications": {
      "title": "Notificaciones del Evento",
      "loading": "Cargando notificaciones...",
      "noNotifications": "No hay notificaciones para este evento.",
      "noNotificationsHint": "Las notificaciones relacionadas con este evento aparecerán aquí.",
      "now": "Ahora",
      "minutesAgo": "Hace {mins} min",
      "hoursAgo": "Hace {hours} h",
      "daysAgo": "Hace {days} d",
      "eventNotification": "Notificación del evento",
      "noMessage": "Sin mensaje",
      "new": "Nueva",
      "markAsRead": "Marcar como leída"
    },
    "location": {
      "title": "Ubicación",
      "openInMaps": "Abrir en Google Maps",
      "notAvailable": "Ubicación no disponible",
      "howToArrive": "¿Cómo quieres llegar?",
      "byCar": "En coche",
      "byTransit": "Transporte público",
      "byBicycle": "En bicicleta",
      "byWalking": "Caminando",
      "gettingLocation": "Obteniendo tu ubicación...",
      "cantCalculate": "No se puede calcular la ruta sin una ubicación válida."
    },
    "errors": {
      "profileNotFound": "No pudimos identificar tu perfil. Recarga la página e inténtalo de nuevo.",
      "registrationFailed": "No pudimos completar tu registro. Inténtalo de nuevo en unos segundos.",
      "registrationError": "Ocurrió un error al registrar tu asistencia. Por favor, inténtalo más tarde.",
      "unregisterConfirm": "¿Estás seguro de que quieres desinscribirte de este evento?",
      "unregisterFailed": "No pudimos cancelar tu registro. Inténtalo de nuevo en unos segundos.",
      "unregisterError": "Ocurrió un error al cancelar tu registro. Por favor, inténtalo más tarde.",
      "geolocationNotSupported": "Geolocalización no soportada",
      "locationNotAvailable": "Ubicación no disponible",
      "locationAccessDenied": "No pudimos acceder a tu ubicación. Abriendo Maps con el destino del evento.",
      "directionsError": "Ocurrió un error al abrir las direcciones.",
      "loadAttendeesError": "No pudimos cargar los asistentes confirmados."
    }
  },
  "calendar": {
    "confirmationTitle": "¡Inscripción completada!",
    "confirmationSubtitle": "Te esperamos en {eventTitle}",
    "addToGoogleCalendar": "Añadir a Google Calendar",
    "addToAppleCalendar": "Añadir a Apple Calendar",
    "addToCalendar": "Añadir al calendario",
    "hint": "Esto añadirá el evento a tu calendario. Puedes editarlo después.",
    "downloadICS": "Descargar archivo .ics"
  },
  "profile": {
    "loading": "Cargando perfil...",
    "editPhoto": "Editar foto de perfil",
    "avatarUpdateError": "No se pudo guardar la foto de perfil. Inténtalo de nuevo.",
    "avatarUploadError": "No se pudo subir la foto. Inténtalo de nuevo.",
    "avatarCropTitle": "Ajusta tu foto",
    "avatarCropHint": "Arrastra y usa el zoom para encajar el rostro dentro del círculo.",
    "avatarCropZoom": "Zoom",
    "avatarCropCancel": "Cancelar",
    "avatarCropSave": "Usar foto",
    "avatarCropError": "No se pudo recortar la imagen. Inténtalo de nuevo.",
    "avatarCropInvalidType": "Selecciona un archivo de imagen válido.",
    "roles": {
      "admin": "Administrador",
      "user": "Usuario"
    },
    "experience": {
      "beginner": "Principiante",
      "intermediate": "Intermedio",
      "advanced": "Avanzado",
      "expert": "Experto"
    },
    "whoAmI": {
      "student": "Estudiante",
      "professional": "Profesional",
      "entrepreneur": "Emprendedor",
      "investor": "Inversor",
      "mentor": "Mentor",
      "other": "Otro"
    },
    "goals": {
      "networking": "Networking",
      "learn": "Aprender",
      "opportunities": "Oportunidades",
      "mentorship": "Mentoría",
      "collaborate": "Colaborar",
      "share": "Compartir",
      "personalBrand": "Marca Personal",
      "explore": "Explorar"
    },
    "tabs": {
      "aboutMe": "Sobre Mí",
      "networking": "Networking",
      "info": "Información",
      "interests": "Intereses",
      "social": "Redes Sociales"
    },
    "completeness": {
      "label": "Perfil completado",
      "subtitle": "Completa tu perfil para recibir mejores sugerencias de networking.",
      "matchHint": "Los perfiles con más información reciben mejores matches de networking.",
      "completeProfile": "Completar perfil",
      "completeNext": "Completar",
      "allDone": "¡Perfil completo! Recibirás los mejores matches.",
      "personalInfo": "Información personal",
      "interests": "Intereses",
      "eventObjective": "Objetivo en el evento",
      "socialNetworks": "Redes sociales",
      "professionalExperience": "Experiencia profesional",
      "bio": "Bio",
      "networkingLevel": "Nivel Networking",
      "hint_personal_info": "Añade tu nombre y apellido",
      "hint_interests": "Añade tus intereses profesionales",
      "hint_event_objective": "Indica tu objetivo en el evento",
      "hint_social_networks": "Añade al menos una red social",
      "hint_professional_experience": "Indica tu rol y nivel de experiencia",
      "hint_bio": "Añade una bio breve sobre ti"
    },
    "networking": {
      "title": "Networking",
      "seeking": "Busco conectar con",
      "seekingTagInputPlaceholder": "Escribe el tipo de personas que quieres conocer y pulsa Enter (ej. fundadores, inversores, desarrolladores)",
      "offering": "Qué ofrezco",
      "offeringTagInputPlaceholder": "Escribe qué puedes ofrecer y pulsa Enter (ej. mentoría, colaboración, contratación)",
      "eventObjective": "Objetivo en el evento",
      "bioShort": "Bio (máx 200 caracteres)",
      "bioShortPlaceholder": "Ej: Founder building AI products. Interested in meeting developers and investors.",
      "professionalKeywords": "Tags profesionales",
      "seeking_investors": "Inversores",
      "seeking_founders": "Fundadores",
      "seeking_developers": "Desarrolladores",
      "seeking_designers": "Diseñadores",
      "seeking_marketing": "Marketing",
      "seeking_product_managers": "Product Managers",
      "offering_mentorship": "Mentoría",
      "offering_investment": "Inversión",
      "offering_collaboration": "Colaboración",
      "offering_hiring": "Contratar talento",
      "offering_finding_partners": "Buscar socios",
      "offering_sharing_knowledge": "Compartir conocimiento",
      "eventObjective_networking": "Networking",
      "eventObjective_finding_partners": "Buscar socios",
      "eventObjective_finding_clients": "Buscar clientes",
      "eventObjective_investment": "Inversión",
      "eventObjective_learning": "Aprender",
      "eventObjective_recruiting": "Reclutar talento"
    },
    "matchScore": {
      "title": "Tu perfil genera matches con",
      "subtitle": "Completa tu perfil para mejorar las sugerencias.",
      "empty": "Completa tu sección Networking para ver compatibilidades.",
      "developersAI": "Desarrolladores IA",
      "foundersSaaS": "Fundadores SaaS",
      "investors": "Inversores",
      "developers": "Desarrolladores",
      "designers": "Diseñadores",
      "marketing": "Marketing",
      "productManagers": "Product Managers",
      "fintech": "Fintech / Blockchain"
    },
    "aboutMe": {
      "title": "Sobre Mí",
      "edit": "Editar",
      "biography": "Biografía",
      "biographyPlaceholder": "Describe brevemente qué haces y con quién te gustaría conectar (ej. Founder creando productos de IA, interesado en conocer desarrolladores e inversores).",
      "cancel": "Cancelar",
      "save": "Guardar",
      "noBio": "Añade una bio breve para que otros asistentes entiendan rápidamente quién eres.",
      "addBio": "Añadir bio",
      "whatIDo": "Lo Que Hago",
      "noWhatIDo": "Completa esta sección para que otros sepan a qué te dedicas.",
      "role": "Rol",
      "experience": "Experiencia",
      "goals": "Metas",
      "preferences": "Preferencias"
    },
    "personalInfo": {
      "title": "Información Personal",
      "edit": "Editar",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "birthDate": "Fecha de Nacimiento",
      "phone": "Teléfono",
      "email": "Correo Electrónico",
      "systemRole": "Rol del Sistema",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "address": {
      "title": "Dirección",
      "edit": "Editar",
      "city": "Ciudad",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "interests": {
      "title": "Intereses",
      "edit": "Editar",
      "placeholder": "Innovación, Startups, Diseño...",
      "tagInputPlaceholder": "Escribe un interés y pulsa Enter (ej. IA, Startups, Diseño)",
      "label": "Intereses",
      "cancel": "Cancelar",
      "save": "Guardar",
      "general": "Intereses Generales",
      "onboarding": "Intereses del Onboarding",
      "noInterests": "Todavía no has añadido intereses."
    },
    "social": {
      "title": "Redes Sociales",
      "edit": "Editar",
      "linkedin": "LinkedIn",
      "linkedinPlaceholder": "https://linkedin.com/in/usuario",
      "twitter": "X (Twitter)",
      "twitterPlaceholder": "https://twitter.com/usuario",
      "instagram": "Instagram",
      "instagramPlaceholder": "https://instagram.com/usuario",
      "github": "GitHub",
      "githubPlaceholder": "https://github.com/usuario",
      "facebook": "Facebook",
      "facebookPlaceholder": "https://facebook.com/usuario",
      "youtube": "YouTube",
      "youtubePlaceholder": "https://youtube.com/canal",
      "tiktok": "TikTok",
      "tiktokPlaceholder": "https://tiktok.com/@usuario",
      "website": "Sitio Web",
      "websitePlaceholder": "https://mi-sitio.com",
      "cancel": "Cancelar",
      "save": "Guardar",
      "noSocial": "Todavía no has añadido redes sociales.",
      "emptyHint": "Añade tus redes para que otros asistentes puedan conocerte mejor.",
      "addSocialNetworks": "Añadir redes sociales"
    },
    "errors": {
      "noChanges": "No hay cambios para guardar.",
      "updateError": "Error: No se pudo actualizar el perfil. Inténtalo de nuevo.",
      "saveError": "Error: Ocurrió un error al guardar el perfil. Inténtalo de nuevo.",
      "avatarError": "Error al actualizar el avatar"
    }
  },
  "votacion": {
    "title": "¡Ayúdanos!",
    "subtitle": "Tu opinión es muy valiosa para nosotros. Comparte tus sugerencias, ideas y comentarios para ayudarnos a mejorar.",
    "form": {
      "loading": "Cargando formulario...",
      "eventLabel": "Selecciona el evento",
      "foundErrorsLabel": "¿Has encontrado errores?",
      "yes": "Sí",
      "no": "No",
      "errorDetailsLabel": "Si es así, ¿cuáles?",
      "errorDetailsPlaceholder": "Cuéntanos qué errores encontraste para poder corregirlos.",
      "commentLabel": "Algo que quieras comentar acerca del evento (opcional)",
      "commentPlaceholder": "Puede ser una crítica constructiva, lo que te haya parecido el evento o cualquier cosa que te apetezca.",
      "submit": "Enviar feedback",
      "submitting": "Enviando feedback..."
    },
    "messages": {
      "profileError": "No hemos podido cargar tu perfil. Inténtalo de nuevo.",
      "selectEventRequired": "Selecciona un evento para continuar.",
      "selectErrorsRequired": "Indica si encontraste errores.",
      "errorDetailsRequired": "Cuéntanos qué errores encontraste.",
      "submitError": "No se pudo enviar tu feedback. Inténtalo de nuevo.",
      "submitSuccess": "Gracias por ayudarnos a mejorar. Tu feedback se envió correctamente.",
      "noEligibleEvents": "Todavía no tienes eventos disponibles para valorar.",
      "alreadySentForEvent": "Ya nos enviaste feedback para este evento.",
      "pickAnotherEvent": "Si quieres, elige otro evento para enviarnos más feedback."
    }
  },
  "admin": {
    "title": "Administración",
    "eventos": "Eventos",
    "usuarios": "Usuarios",
    "organizaciones": "Empresas",
    "permisos": "Permisos",
    "rankings": "Rankings",
    "encuentros": "Encuentros",
    "informes": "Informes y Métricas",
    "notificaciones": "Notificaciones",
    "dashboard": "Dashboard",
    "dashboardTitle": "Dashboard",
    "dashboardSubtitle": "Resumen global de la plataforma",
    "dashboardKpiEvents": "Total eventos",
    "dashboardKpiUsers": "Total usuarios",
    "dashboardKpiOrganizations": "Empresas",
    "dashboardKpiUpcoming": "Próximos eventos",
    "dashboardKpiPublished": "Publicados",
    "dashboardKpiDraft": "Borradores",
    "dashboardKpiPast": "Finalizados",
    "dashboardKpiCancelled": "Cancelados",
    "dashboardUpcomingEvents": "Próximos eventos",
    "dashboardQuickActions": "Acciones rápidas",
    "dashboardViewEvents": "Ver eventos",
    "dashboardViewUsers": "Ver usuarios",
    "dashboardViewOrganizations": "Ver empresas",
    "dashboardViewReports": "Ver informes",
    "dashboardViewNotifications": "Ver notificaciones",
    "dashboardNewEvent": "Nuevo evento",
    "dashboardNoUpcoming": "No hay próximos eventos",
    "dashboardEventDate": "Fecha",
    "dashboardLoading": "Cargando resumen...",
    "dashboardTodayBanner": "{count} eventos comienzan HOY",
    "dashboardPlatformHealth": "Salud de Plataforma",
    "dashboardHealthNewUsers": "Usuarios nuevos (7 días)",
    "dashboardHealthPublishedEvents": "Eventos publicados",
    "dashboardHealthNewOrgs": "Empresas nuevas (7 días)",
    "dashboardDraftPastSummary": "{draft} borradores · {past} finalizados",
    "dashboardBadgeLive": "EN VIVO",
    "dashboardBadgeScheduled": "PROGRAMADO",
    "dashboardViewAllUpcoming": "Ver todos ({count}) →",
    "dashboardNewOrganization": "Nueva Empresa",
    "dashboardViewPermissions": "Ver Permisos",
    "nuevoEvento": "Nuevo Evento",
    "organizacionesTitle": "Empresas",
    "organizacionesSubtitle": "Gestiona las empresas de la plataforma",
    "permisosTitle": "Permisos de organizador",
    "permisosSubtitle": "Asigna o quita el rol de organizador y asocia usuarios a empresas",
    "crearOrganizacion": "Crear empresa",
    "crearOrganizacionHint": "La empresa se creará con tu usuario como propietario y organizador.",
    "asignarOrganizador": "Asignar como organizador",
    "seleccionarOrganizacion": "Seleccionar empresa",
    "sinOrganizacionesPermisos": "Crea una empresa en la pestaña Empresas para poder asignar.",
    "quitarOrganizador": "Quitar rol organizador",
    "asociarAOrganizacion": "Asociar a organización",
    "nombreOrganizacion": "Nombre",
    "miembros": "Miembros",
    "propietario": "Propietario",
    "sinOrganizaciones": "No hay empresas",
    "gestionarPermisos": "Gestionar permisos",
    "gestionarEquipo": "Gestionar equipo",
    "equipoTitle": "Equipo de «{name}»",
    "equipoDescription": "Añade usuarios a esta empresa. Cada usuario solo puede pertenecer a una empresa.",
    "equipoEmpty": "No hay miembros en esta empresa",
    "equipoSelectUser": "Seleccionar usuario",
    "equipoSearchUser": "Buscar por nombre o email…",
    "equipoSearchMin": "Escribe al menos 2 caracteres",
    "equipoSearchEmpty": "No se encontraron usuarios",
    "equipoClearSelection": "Quitar selección",
    "equipoAdd": "Añadir al equipo",
    "rolOrganizador": "Organizador",
    "rolMiembro": "Miembro",
    "quitarMiembro": "Quitar",
    "panelScreens": "Pantallas del panel",
    "panelScreensTitle": "Pantallas visibles en el panel organizador",
    "panelScreensDescription": "Activa o desactiva las secciones que verán los organizadores de esta empresa.",
    "panelScreenDashboard": "Dashboard",
    "panelScreenEvents": "Eventos",
    "panelScreenAttendees": "Asistentes",
    "panelScreenNetworking": "Networking",
    "panelScreenAnalytics": "Analytics",
    "panelScreenNotifications": "Notificaciones",
    "panelScreenSettings": "Ajustes organización",
    "eliminarEmpresa": "Eliminar empresa",
    "confirmarEliminarEmpresa": "Eliminar empresa",
    "confirmarEliminarEmpresaHint": "¿Eliminar la empresa «{name}»? Se quitará a los miembros y los eventos quedarán sin empresa asignada.",
    "panelScreensSave": "Guardar pantallas",
    "panelScreensAll": "Todas",
    "eventosSubtitle": "Gestiona todos los eventos de la plataforma",
    "usuariosSubtitle": "Administra usuarios y permisos",
    "rankingsSubtitle": "Rankings de usuarios por conexiones y actividad",
    "encuentrosSubtitle": "Encuentros físicos confirmados por QR entre usuarios conectados",
    "meetups": {
      "loading": "Cargando encuentros…",
      "kpiTotal": "Total confirmados",
      "kpi24h": "Últimas 24 h",
      "kpi7d": "Últimos 7 días",
      "searchPlaceholder": "Buscar por nombre o email…",
      "empty": "Aún no hay encuentros confirmados por QR",
      "emptyHint": "Cuando dos usuarios confirmen un encuentro en persona, aparecerá aquí.",
      "noSearchResults": "Sin resultados",
      "noSearchResultsHint": "Prueba con otro nombre o email.",
      "colUserA": "Usuario A",
      "colUserB": "Usuario B",
      "colDate": "Fecha",
      "colMethod": "Método",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "informesSubtitle": "Métricas en tiempo real para eventos futuros e informes completos para eventos pasados",
    "notificacionesSubtitle": "Envía notificaciones a todos los usuarios o a usuarios seleccionados",
    "filterOptions": "Opciones de filtrado",
    "filterAll": "Todos",
    "filterUpcoming": "Próximos",
    "filterPast": "Pasados",
    "filterCancelled": "Cancelados",
    "filterAdmins": "Administradores",
    "filterUsers": "Usuarios",
    "rankingByConnections": "Por conexiones totales",
    "rankingMostConnected": "Más conectados",
    "rankingByConnectionsTitle": "Ranking por conexiones",
    "rankingMostConnectedTitle": "Usuarios más conectados",
    "rankingType": "Tipo de ranking",
    "tableTitle": "Título",
    "tableDate": "Fecha",
    "tableLocation": "Ubicación",
    "tableStatus": "Estado",
    "tableActions": "Acciones",
    "tableName": "Nombre",
    "tableEmail": "Email",
    "tableRole": "Rol",
    "tableOrganizer": "Organizador",
    "tablePosition": "Posición",
    "tableSent": "Enviadas",
    "tableReceived": "Recibidas",
    "tableAccepted": "Aceptadas",
    "tableTotal": "Total",
    "tableConnections": "Conexiones",
    "tableUser": "Usuario",
    "statusUpcoming": "Próximo",
    "statusPast": "Pasado",
    "statusCancelled": "Cancelado",
    "roleAdmin": "Admin",
    "roleUser": "Usuario",
    "loading": "Cargando...",
    "loadingEvents": "Cargando eventos...",
    "loadingUsers": "Cargando usuarios...",
    "loadingRankings": "Cargando rankings...",
    "noEvents": "No hay eventos",
    "noUsers": "No hay usuarios",
    "noRankings": "No hay datos de rankings disponibles",
    "makeAdmin": "Hacer Admin",
    "removeAdmin": "Quitar Admin",
    "eventsCount": "Eventos",
    "usersCount": "Usuarios",
    "confirmDeleteEvent": "¿Estás seguro de que deseas eliminar el evento \"{title}\"? Esta acción no se puede deshacer.",
    "roleUpdated": "Rol actualizado correctamente",
    "roleUpdateError": "No se pudo actualizar el rol",
    "eventDeleted": "Evento eliminado correctamente",
    "eventDeleteError": "No se pudo eliminar el evento",
    "orgCreated": "Organización creada correctamente",
    "orgCreateError": "No se pudo crear la organización"
  },
  "organizer": {
    "title": "Panel de organizador",
    "dashboard": "Dashboard",
    "events": "Eventos",
    "attendees": "Asistentes",
    "networking": "Networking",
    "analytics": "Analytics",
    "notifications": "Notificaciones",
    "settings": "Ajustes organización",
    "loading": "Cargando...",
    "selectEvent": "Selecciona un evento",
    "noData": "Sin datos",
    "noDataDescription": "No se pudieron cargar los datos.",
    "dashboardTitle": "Dashboard",
    "dashboardDescription": "Resumen de tus eventos y métricas. Selecciona una sección del menú para empezar.",
    "dashboardLoading": "Cargando resumen...",
    "dashboardKpiTotalEvents": "Total eventos",
    "dashboardKpiDraft": "Borradores",
    "dashboardKpiPublished": "Publicados",
    "dashboardKpiPast": "Finalizados",
    "dashboardKpiCancelled": "Cancelados",
    "dashboardKpiTotalAttendees": "Asistentes registrados",
    "dashboardKpiTotalActiveAttendees": "Asistentes activos",
    "dashboardNoPublishedHint": "Aún no tienes eventos publicados. Publica uno para ver métricas.",
    "dashboardKpiTotalConnections": "Conexiones generadas",
    "dashboardKpiTotalMessages": "Mensajes enviados",
    "dashboardKpiAvgConnections": "Conexiones por evento (media)",
    "dashboardKpiAvgProfile": "Perfil completado (media)",
    "dashboardUpcomingEvents": "Próximos eventos",
    "dashboardNoUpcoming": "No hay eventos próximos",
    "dashboardNoUpcomingDescription": "Publica un evento para que aparezca aquí.",
    "dashboardTopNetworking": "Eventos con más networking",
    "dashboardTopNetworkingConnections": "conexiones",
    "dashboardNoNetworking": "Sin datos de networking",
    "dashboardNoNetworkingDescription": "Cuando tus eventos generen conexiones, aparecerán aquí.",
    "dashboardCreateEvent": "Crear evento",
    "dashboardViewAnalytics": "Ver analytics",
    "dashboardViewEvents": "Ver eventos",
    "dashboardEmptyTitle": "Aún no tienes eventos",
    "dashboardEmptyDescription": "Crea tu primer evento para empezar a ver métricas y estadísticas.",
    "dashboardEventDate": "Fecha",
    "dashboardEventAttendees": "asistentes",
    "dashboardKpiRegistered": "Inscritos totales",
    "dashboardKpiAttendance": "Asistencia",
    "dashboardKpiEngagement": "Engagement",
    "dashboardTrendThisWeek": "esta semana",
    "dashboardNextActions": "Próximas acciones",
    "dashboardActionEventsWeek": "{count} eventos comienzan esta semana",
    "dashboardActionPendingCheckIn": "{count} inscritos sin check-in confirmado",
    "dashboardActionConnections": "Revisa las nuevas conexiones en Networking",
    "dashboardMyEvents": "Mis eventos",
    "dashboardAttendeesShort": "inscritos",
    "dashboardBadgeLive": "EN DIRECTO",
    "dashboardBadgeScheduled": "Programado",
    "dashboardQuickActionsTitle": "Acciones",
    "dashboardViewAttendees": "Ver asistentes",
    "dashboardSendNotification": "Enviar notificación",
    "dashboardQuickAnalytics": "Analytics rápido",
    "dashboardExportCsv": "Exportar CSV",
    "eventsTitle": "Eventos",
    "eventsNew": "Nuevo evento",
    "eventsFilterStatus": "Estado:",
    "eventsFilterAll": "Todos",
    "eventsFilterPublished": "Publicados",
    "eventsFilterDraft": "Borrador",
    "eventsFilterPast": "Pasados",
    "eventsFilterCancelled": "Cancelados",
    "eventsFilterUpcoming": "Próximos",
    "eventsFilterDate": "Fecha:",
    "eventsTableLocation": "Ubicación",
    "eventsStatusPublished": "Publicado",
    "eventsStatusDraft": "Borrador",
    "eventsStatusArchived": "Archivado",
    "eventsStatusCancelled": "Cancelado",
    "eventsTableTitle": "Título",
    "eventsTableDate": "Fecha",
    "eventsTableStatus": "Estado",
    "eventsTableCapacity": "Capacidad",
    "eventsTableActions": "Acciones",
    "eventsEdit": "Editar",
    "eventsCopyLink": "Copiar enlace",
    "eventsLinkCopied": "Enlace copiado",
    "eventsLanding": "Landing",
    "eventsPublish": "Publicar",
    "eventsUnpublish": "Despublicar",
    "eventsArchive": "Archivar",
    "eventsCancel": "Cancelar evento",
    "eventsNoEvents": "No hay eventos",
    "eventsNoEventsDescription": "Crea tu primer evento para empezar.",
    "eventsNoCapacity": "Sin límite",
    "eventNewTitle": "Nuevo evento",
    "eventNewNoOrg": "Necesitas pertenecer a una organización para crear eventos. Crea una organización primero o pide que te añadan como org_admin.",
    "eventNewBackToEvents": "Volver a Eventos",
    "eventEditTitle": "Editar evento",
    "attendeesTitle": "Asistentes",
    "attendeesSendNotification": "Enviar notificación",
    "attendeesNoAttendees": "No hay asistentes",
    "attendeesNoAttendeesDescription": "Aún no hay inscritos en este evento.",
    "attendeesLoading": "Cargando asistentes...",
    "attendeesTableName": "Nombre",
    "attendeesTableEmail": "Email",
    "attendeesTableStatus": "Estado",
    "attendeesTableDate": "Fecha registro",
    "attendeesTableProfile": "Perfil",
    "networkingTitle": "Networking",
    "networkingLoading": "Cargando métricas...",
    "networkingSentRequests": "Solicitudes enviadas",
    "networkingAcceptedRequests": "Solicitudes aceptadas",
    "networkingTotalConnections": "Conexiones totales",
    "networkingAcceptanceRatio": "Ratio aceptación",
    "networkingTopConnectors": "Top conectores",
    "networkingNoData": "Sin datos",
    "networkingNoDataDescription": "Aún no hay conexiones entre asistentes.",
    "networkingNoDataGeneric": "No se pudieron cargar las métricas.",
    "networkingConnections": "conexiones",
    "networkingAttendeesCount": "Asistentes inscritos",
    "networkingHintLowEngagement": "Solo una parte de los asistentes ha generado conexiones.",
    "networkingHintCta": "Envía una notificación para animar al networking",
    "analyticsTitle": "Analytics",
    "analyticsLoading": "Cargando analytics...",
    "analyticsRegistered": "Registrados",
    "analyticsActive": "Activos",
    "analyticsActiveHelp": "Inscritos marcados como «asistiendo» (check-in durante el evento)",
    "analyticsTotalAttendedHelp": "Inscritos marcados como «asistieron» tras el evento",
    "analyticsRegisteredHelp": "Solo quienes pulsaron «Inscribirse» al evento en la app (no todos los usuarios con cuenta)",
    "analyticsProfileComplete": "% Perfil completo",
    "analyticsSentRequests": "Solicitudes enviadas",
    "analyticsAcceptedRequests": "Solicitudes aceptadas",
    "analyticsTotalConnections": "Conexiones totales",
    "analyticsAcceptanceRatio": "Ratio aceptación",
    "analyticsMessagesSent": "Mensajes enviados",
    "analyticsActiveConversations": "Conversaciones activas",
    "analyticsActiveConversationsHelp": "Chats con al menos un mensaje (DMs entre asistentes + chat del evento)",
    "analyticsConnectionsPerAttendee": "Conexiones por asistente (media)",
    "analyticsFunnel": "Embudo",
    "analyticsRegistrationsByDay": "Registros por día",
    "analyticsDate": "Fecha",
    "analyticsRegistrations": "Registros",
    "analyticsTopInterests": "Top intereses",
    "analyticsTopGoals": "Top objetivos",
    "analyticsShareableSummary": "Resumen compartible",
    "meetups": {
      "sectionTitle": "Encuentros confirmados",
      "kpiTotal": "Total",
      "kpi24h": "Últimas 24 h",
      "kpi7d": "Últimos 7 días",
      "empty": "Sin encuentros confirmados",
      "emptyHint": "Aquí aparecen los encuentros físicos que hacen los asistentes de este evento al confirmar con QR de una sola vez.",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "analyticsCopyClipboard": "Copiar al portapapeles",
    "analyticsCopied": "Copiado",
    "analyticsNoData": "Sin datos",
    "analyticsNoDataDescription": "No se pudieron cargar las métricas para este evento.",
    "analyticsFilterAll": "Todos",
    "analyticsFilterUpcoming": "Próximos",
    "analyticsFilterPast": "Finalizados",
    "analyticsEventHeaderViewEvent": "Ver evento",
    "analyticsEventHeaderCopyLink": "Copiar enlace",
    "analyticsEventHeaderViewAttendees": "Ver asistentes",
    "analyticsEventHeaderSendNotification": "Enviar notificación",
    "analyticsStatusUpcoming": "Próximo",
    "analyticsStatusOngoing": "En curso",
    "analyticsStatusPast": "Finalizado",
    "analyticsStatusCancelled": "Cancelado",
    "analyticsSectionAttendance": "Asistencia y registro",
    "analyticsSectionNetworking": "Networking y engagement",
    "analyticsSectionFunnel": "Embudo de participación",
    "analyticsSectionSummary": "Resumen compartible",
    "analyticsLastUpdate": "Última actualización",
    "analyticsEmptyNoEvents": "Aún no tienes eventos",
    "analyticsEmptyNoEventsDescription": "Crea tu primer evento para ver analíticas.",
    "analyticsEmptyNoRegistrations": "Aún no hay inscritos en este evento.",
    "analyticsEmptyNoNetworkingTitle": "Sin actividad de networking aún",
    "analyticsEmptyNoNetworkingCta": "Envía una notificación para activar el networking entre asistentes.",
    "analyticsMetricUnavailable": "Sin datos aún",
    "analyticsCopySummary": "Copiar resumen",
    "analyticsFunnelRegistered": "Registrados",
    "analyticsFunnelProfileComplete": "Perfil completo",
    "analyticsFunnelSentRequest": "Envían solicitud",
    "analyticsFunnelConnected": "Conectan",
    "analyticsFunnelChatted": "Chatean",
    "analyticsTotalRegistered": "Total registrados",
    "analyticsTotalAttended": "Total asistidos",
    "analyticsAttendanceRate": "Tasa de asistencia",
    "analyticsCancelled": "Cancelados",
    "analyticsSelectEventPlaceholder": "Seleccionar evento",
    "analyticsEmptySelectEvent": "Selecciona un evento para ver las métricas",
    "notificationsTitle": "Notificaciones",
    "notificationsSendToAttendees": "Enviar a asistentes del evento",
    "notificationsTitlePlaceholder": "Título",
    "notificationsMessagePlaceholder": "Mensaje",
    "notificationsSend": "Enviar",
    "notificationsSending": "Enviando...",
    "notificationsHistory": "Historial de campañas",
    "notificationsNoCampaigns": "Sin campañas",
    "notificationsNoCampaignsDescription": "Aún no has enviado notificaciones a este evento.",
    "settingsPageTitle": "Ajustes",
    "settingsOrgSection": "Organización",
    "settingsOrgName": "Nombre de la organización",
    "settingsTeamSection": "Equipo",
    "settingsTeamRoleAdmin": "Administrador",
    "settingsTeamRoleMember": "Miembro",
    "settingsTeamRemove": "Quitar del equipo",
    "settingsRemoveConfirm": "¿Quitar a este usuario del equipo?",
    "settingsTeamOwner": "propietario",
    "settingsTableName": "Nombre",
    "settingsTableEmail": "Email",
    "settingsTableRole": "Rol",
    "settingsSave": "Guardar",
    "settingsSaved": "Guardado",
    "settingsLoading": "Cargando…",
    "settingsNoOrg": "No tienes ninguna organización. Créala desde el panel de administración.",
    "brandingSectionTitle": "Marca de la empresa",
    "brandingSectionDesc": "Logo y colores que se aplican a los eventos de tu organización.",
    "brandingLogoLabel": "Logo",
    "brandingLogoHint": "Arrastra una imagen o haz clic (máx. 2 MB)",
    "brandingLogoUpload": "Subir logo",
    "brandingLogoRemove": "Quitar logo",
    "brandingUploading": "Subiendo…",
    "brandingPrimary": "Color primario",
    "brandingSecondary": "Color secundario",
    "brandingContrastWarning": "El color secundario puede tener poco contraste con texto blanco en badges.",
    "brandingPreviewLabel": "Vista previa en vivo",
    "brandingSaved": "Marca guardada",
    "brandingSaveError": "No se pudo guardar la marca",
    "brandingUploadError": "Error al subir el logo",
    "plataforma": "Plataforma",
    "dashboardCreateEventShort": "+ Crear evento",
    "dashboardViewAllEvents": "Ver todos ({count})"
  },
  "panel": {
    "title": "Panel",
    "admin": "Panel de administración",
    "organizer": "Panel de organizador",
    "desktopOnly": {
      "title": "Disponible en tablet y escritorio",
      "description": "Los paneles de administración y organizador están pensados para pantallas más grandes. Ábrelos desde una tablet o un ordenador.",
      "backToEvents": "Volver a eventos"
    }
  },
  "aboutUs": {
    "title": "Quiénes somos",
    "subtitle": "Conoce la misión y la comunidad de Biavent",
    "hero": {
      "title": "Bienvenido a Biavent"
    }
  },
  "navigation": {
    "eventos": "Eventos",
    "chats": "Chats",
    "perfil": "Perfil",
    "ajustes": "Ajustes",
    "votacion": "¡Ayúdanos!",
    "quienesSomos": "Quiénes somos",
    "actividad": "Actividad",
    "closeMenu": "Cerrar menú",
    "panel": "Panel",
    "panelAdmin": "Panel de administración",
    "panelOrganizer": "Panel de organizador"
  },
  "chats": {
    "title": "Chats",
    "activity": {
      "feedTitle": "Actividad",
      "feedSubtitle": "Solicitudes, mensajes y conexiones",
      "markAllRead": "Marcar todo como leído",
      "error": "No se pudo cargar la actividad.",
      "retry": "Reintentar",
      "empty": "No tienes actividad todavía",
      "emptyHint": "Las solicitudes de conexión, aceptaciones y mensajes aparecerán aquí.",
      "exploreEvents": "Explorar eventos",
      "someone": "Alguien",
      "newMessage": "Nuevo mensaje",
      "sentRequest": "te ha enviado una solicitud",
      "requestSent": "Solicitud enviada",
      "requestAccepted": "ha aceptado tu solicitud"
    },
    "recentActivity": "Tu actividad reciente",
    "loading": "Cargando...",
    "noChats": "Todavía no tienes chats",
    "noChatsHint": "Regístrate en un evento para poder conectar y hablar con más gente",
    "tabs": {
      "activity": "Actividad",
      "connections": "Conexiones",
      "chats": "Chats"
    },
    "requests": {
      "title": "Solicitudes",
      "allContacts": "Todos tus contactos",
      "favorites": "Favoritos",
      "sent": {
        "title": "Solicitudes Enviadas",
        "pending": "solicitud pendiente",
        "pendingPlural": "solicitudes pendientes",
        "waiting": "Esperando respuesta",
        "cancel": "Cancelar"
      },
      "received": {
        "title": "Solicitudes de Conexión",
        "pending": "solicitud pendiente",
        "pendingPlural": "solicitudes pendientes",
        "wantsToConnect": "Quiere conectarse contigo",
        "accept": "Aceptar",
        "reject": "Rechazar",
        "noPending": "No hay solicitudes pendientes"
      }
    },
    "contacts": {
      "noContacts": "No tienes contactos conectados",
      "noContactsHint": "Conecta con otros usuarios para verlos aquí",
      "removeFavorite": "Quitar de favoritos",
      "addFavorite": "Añadir a favoritos",
      "openChat": "Abrir chat",
      "noFavorites": "No tienes contactos favoritos",
      "noFavoritesHint": "Marca contactos como favoritos para verlos aquí"
    },
    "connections": {
      "acceptSuccessTitle": "Conexión aceptada",
      "acceptSuccessMessage": "Ya puedes chatear con este contacto.",
      "acceptErrorMessage": "No se pudo aceptar la solicitud.",
      "rejectSuccessTitle": "Solicitud rechazada",
      "rejectSuccessMessage": "Has rechazado la solicitud de conexión.",
      "rejectErrorMessage": "No se pudo rechazar la solicitud.",
      "cancelSuccessTitle": "Solicitud cancelada",
      "cancelSuccessMessage": "Has cancelado la solicitud de conexión.",
      "cancelErrorMessage": "No se pudo cancelar la solicitud.",
      "viewRequests": "Ver solicitudes",
      "dmBlockedTitle": "Conexión necesaria",
      "dmBlockedMessage": "Acepta la solicitud de conexión para poder chatear.",
      "alreadyPending": "Ya hay una solicitud pendiente entre vosotros.",
      "alreadyConnected": "Ya estáis conectados.",
      "cooldownActive": "Espera un poco antes de volver a enviar la solicitud.",
      "rateLimited": "Demasiadas solicitudes. Espera un momento e inténtalo de nuevo."
    },
    "search": "Buscar o empezar nuevo chat",
    "noRecentChats": "No hay chats recientes",
    "selectChat": "Selecciona un chat",
    "selectChatHint": "Escoge una conversación de la lista para comenzar a chatear",
    "hub": {
      "searchContacts": "Buscar contactos...",
      "filterAll": "Todos",
      "filterFavorites": "Favoritos",
      "filterRequests": "Solicitudes",
      "pendingBanner": "{count} solicitudes pendientes",
      "pendingBannerAction": "Ver →",
      "noRequests": "No tienes solicitudes pendientes",
      "noContactsSearch": "No se encontraron contactos para \"{query}\"",
      "noConnections": "Aún no tienes conexiones",
      "connectedSince": "Conectados {time}",
      "noMessagesYet": "Sin mensajes aún",
      "youPrefix": "Tú: ",
      "activityUpdate": "Actualización de actividad",
      "nowConnected": "Ahora sois contactos",
      "deleteNotification": "Eliminar notificación",
      "dateToday": "Hoy",
      "dateYesterday": "Ayer",
      "dateThisWeek": "Esta semana",
      "dateOlder": "Anteriores",
      "relativeNow": "ahora",
      "relativeMinutes": "hace {count} min",
      "relativeHours": "hace {count} h",
      "relativeDays": "hace {count} d"
    },
    "dm": {
      "loadingChat": "Cargando chat...",
      "loadingMessages": "Cargando mensajes...",
      "userError": "No se pudo identificar al usuario actual",
      "back": "Volver",
      "options": "Opciones",
      "closeMenu": "Cerrar menú",
      "deleting": "Eliminando...",
      "deleteChat": "Eliminar chat",
      "deleteError": "No se pudo eliminar el chat. Inténtalo de nuevo.",
      "noMessages": "No hay mensajes aún",
      "startConversation": "¡Inicia la conversación!",
      "writeTo": "Escribe a {name}...",
      "writeMessage": "Escribe un mensaje a {name}",
      "send": "Enviar mensaje"
    }
  },
  "dashboardPremium": {
    "greeting": "Bienvenido de nuevo, {name}",
    "contextSummary": "Tienes {events} eventos esta semana y {pending} pendientes de publicar",
    "searchPlaceholder": "Buscar eventos, asistentes…",
    "headerStatEventsWeek": "eventos esta semana",
    "headerStatPending": "pendientes de publicar",
    "createEvent": "Crear evento",
    "viewAnalytics": "Ver analytics",
    "trendVsPrevious": "vs periodo anterior",
    "kpiActiveEvents": "Eventos activos",
    "kpiActiveEventsFooter": "{scheduled} programados · {live} en curso",
    "kpiUsers": "Usuarios registrados",
    "kpiUsersFooter": "+{new} nuevos en el periodo",
    "kpiOrganizations": "Empresas colaboradoras",
    "kpiOrgsFooter": "+{new} nuevas en el periodo",
    "kpiConversion": "Conversión",
    "kpiConversionFooter": "Inscripciones / usuarios",
    "activityTitle": "Resumen de actividad",
    "range7d": "7D",
    "range30d": "30D",
    "range90d": "90D",
    "seriesRegistrations": "Registros",
    "seriesPublications": "Publicaciones",
    "seriesConnections": "Conexiones",
    "chartEmpty": "Sin actividad en este periodo",
    "upcomingTitle": "Próximos eventos",
    "noUpcoming": "No hay próximos eventos",
    "emptyUpcomingHint": "Crea un evento para verlo aquí cuando esté programado.",
    "badgeLive": "EN VIVO",
    "badgeScheduled": "PROGRAMADO",
    "badgeDraft": "BORRADOR",
    "editEvent": "Editar",
    "viewAllUpcoming": "Ver todos ({count}) →",
    "quickActionsTitle": "Acciones rápidas",
    "performanceTitle": "Rendimiento reciente",
    "perfTopRegistrations": "Más inscripciones",
    "perfLowAttendance": "Menor asistencia",
    "perfTopOrgs": "Empresas más activas",
    "perfPendingTasks": "Tareas pendientes",
    "perfEmpty": "Sin datos aún",
    "perfTasksEmpty": "Sin tareas pendientes",
    "taskDrafts": "{count} eventos en borrador",
    "taskUnpublished": "{count} borradores próximos",
    "growthTitle": "Consejos de crecimiento",
    "aiLabel": "Recomendación IA",
    "growthTipDrafts": "Los borradores no generan inscripciones hasta que los publiques.",
    "growthRecDrafts": "Tienes {count} borrador(es). Publica al menos uno para captar asistentes.",
    "growthTipCover": "Los eventos con imagen de portada profesional suelen convertir mejor.",
    "growthRecCover": "Los eventos con portada convierten hasta un {percent}% mejor de media.",
    "growthTipAttendance": "La asistencia está por debajo de tu media.",
    "growthRecAttendance": "Tasa de asistencia actual: {rate}%. Envía recordatorios antes del evento.",
    "growthTipDefault": "Sigue publicando y activando el networking tras cada evento.",
    "growthRecDefault": "Revisa los informes tras cada evento para repetir lo que funciona.",
    "feedTitle": "Actividad reciente",
    "feedEmpty": "Sin actividad reciente",
    "feedRegistration": "Nueva inscripción",
    "feedPlatform": "Plataforma",
    "feedPublished": "Evento publicado",
    "feedNewOrg": "Nueva empresa",
    "loadError": "No se pudo cargar el dashboard",
    "actionNewEventDesc": "Crea un evento en minutos",
    "actionNewOrgDesc": "Alta de nueva empresa",
    "actionUsersDesc": "Usuarios y roles",
    "actionPermissionsDesc": "Organizadores y acceso",
    "actionNotificationsDesc": "Comunicación con asistentes",
    "actionAttendeesDesc": "Inscripciones y check-in",
    "actionAnalyticsDesc": "Networking y engagement",
    "actionExportDesc": "Exportar asistentes"
  },
  "eventWizard": {
    "progressAria": "Progreso del asistente",
    "stepMeta": "Paso {current} de {total}",
    "sections": {
      "identity": "Identidad del evento",
      "visibility": "Visibilidad",
      "configuration": "Configuración",
      "storytelling": "Storytelling",
      "when": "Cuándo",
      "formatAndPlace": "Formato y lugar",
      "arrival": "Llegada",
      "speakers": "Ponentes",
      "agenda": "Agenda",
      "branding": "Branding",
      "review": "Resumen",
      "discovery": "Descubrimiento"
    },
    "steps": {
      "basic": "Básico",
      "location": "Ubicación",
      "speakers": "Speakers",
      "agenda": "Agenda",
      "style": "Estilo",
      "review": "Revisión"
    },
    "nav": {
      "prev": "Anterior",
      "next": "Siguiente",
      "cancel": "Cancelar",
      "draft": "Guardar borrador",
      "publish": "Crear evento",
      "saveChanges": "Guardar cambios",
      "saving": "Guardando..."
    },
    "loading": "Cargando los datos del evento...",
    "previewLive": "Vista previa en vivo",
    "previewPlatform": "Vista previa en la plataforma",
    "edit": "Editar",
    "step1": {
      "title": "Lo esencial de tu evento",
      "description": "Dale a tu evento un título atractivo, una descripción detallada que inspire y selecciona su tipología.",
      "titleLabel": "Título del evento",
      "titlePlaceholder": "Ej: Biavent Networking Night Madrid",
      "titleHint": "Sé claro y descriptivo. Un buen título capta la atención del público objetivo al instante.",
      "visibilityLabel": "¿Privado o público?",
      "visibilityPublic": "Público",
      "visibilityPrivate": "Privado",
      "categoryLabel": "Categoría principal",
      "eventTypeLabel": "Tipo de encuentro",
      "descriptionLabel": "Descripción",
      "descriptionPlaceholder": "Describe qué van a aprender, por qué es único tu evento y a quién va dirigido...",
      "highlightLabel": "Cita destacada (Highlight)",
      "highlightPlaceholder": "Ej: 'El mayor punto de encuentro para desarrolladores e inversores del año.'",
      "highlightHint": "Una frase corta y potente que se resalta visualmente en la landing page del evento.",
      "tipTitle": "Consejo de Biavent",
      "tipText": "El 85% de las inscripciones se deciden gracias a una descripción estructurada y un título conciso. ¡Define bien tu público objetivo!"
    },
    "step2": {
      "title": "Ubicación y fecha",
      "description": "Establece el día, la hora de tu encuentro y define si nos veremos en persona o en formato digital.",
      "dateLabel": "Fecha",
      "timeLabel": "Hora",
      "timePlaceholder": "Ej: 19:00 - 22:00",
      "timezoneLabel": "Zona horaria",
      "locationLabel": "Ubicación o link",
      "locationOnlineLabel": "Enlace de transmisión",
      "locationPlaceholder": "Calle, ciudad o enlace",
      "locationOnlinePlaceholder": "Zoom, Meet, YouTube...",
      "formatLabel": "¿Online o presencial?",
      "formatInPerson": "Presencial",
      "formatOnline": "Online",
      "formatHybrid": "Híbrido",
      "mapButton": "Mapa",
      "venueLabel": "Nombre del local o espacio",
      "venuePlaceholder": "Ej: Racks House, Auditorio Central Campus Tech...",
      "arrivalLabel": "Instrucciones adicionales para llegar",
      "arrivalPlaceholder": "Indicaciones de acceso, parking, planta, etc.",
      "mapsPreviewEmpty": "Introduce una dirección para ver la vista previa en el mapa",
      "capacityLabel": "Aforo / Límite de plazas",
      "capacityPlaceholder": "Ej: 100 — dejar vacío para aforo libre e ilimitado",
      "capacityHint": "Una vez completado el aforo, la aplicación bloqueará las solicitudes de inscripción automáticamente.",
      "latLabel": "Latitud (opcional)",
      "lngLabel": "Longitud (opcional)",
      "latPlaceholder": "Ej: 40.4167",
      "lngPlaceholder": "Ej: -3.7037"
    },
    "step3": {
      "title": "Agrupa tus speakers",
      "description": "Presenta a los ponentes que liderarán las charlas. Puedes añadir su rol, biografía y foto.",
      "emptyTitle": "Sin speakers registrados aún",
      "emptyText": "¿Tu evento contará con conferenciantes? Pulsa el botón inferior para añadirlos. Si se trata de un afterwork o networking informal, puedes avanzar.",
      "addSpeaker": "Agregar speaker",
      "nameLabel": "Nombre",
      "roleLabel": "Rol",
      "bioLabel": "Bio corta",
      "bioPlaceholder": "Breve biografía...",
      "experienceLabel": "Experiencia profesional",
      "experiencePlaceholder": "Roles, empresas, áreas de especialización...",
      "careerPathLabel": "Trayectoria",
      "careerPathPlaceholder": "Hitos relevantes de su carrera...",
      "additionalInfoLabel": "Información adicional",
      "additionalInfoPlaceholder": "Enlaces, premios, datos opcionales...",
      "avatarLabel": "Foto (URL)",
      "avatarPlaceholder": "https://...",
      "dragTitle": "Arrastrar para reordenar",
      "avatarUpload": "Subir foto",
      "avatarUploading": "Subiendo...",
      "deleteSpeaker": "Eliminar"
    },
    "step4": {
      "title": "Programa y agenda detallada",
      "description": "Describe las actividades del evento paso a paso para que los asistentes planifiquen su jornada.",
      "emptyTitle": "Agenda vacía",
      "emptyText": "Pulsa en «Agregar slot» para ingresar las actividades del evento (recepción, charlas, networking libre, etc.).",
      "addSlot": "Agregar slot",
      "startLabel": "Inicio",
      "endLabel": "Fin",
      "activityLabel": "Actividad",
      "deleteSlot": "Eliminar slot",
      "slotTitlePlaceholder": "Networking, charla...",
      "activityFallback": "Actividad"
    },
    "step5": {
      "title": "Estilo e identidad de marca",
      "description": "Sube portadas, logos corporativos y selecciona la paleta de colores para las tarjetas y botones.",
      "bannerLabel": "Imagen de portada / Banner",
      "bannerUpload": "Subir imagen principal (1200×630)",
      "bannerUploading": "Subiendo imagen...",
      "bannerRemove": "Eliminar portada",
      "bannerUrlHint": "O pega una URL de imagen:",
      "logoLabel": "Logo de la empresa u organizador",
      "logoUpload": "Subir logo corporativo",
      "logoUploading": "Subiendo logo...",
      "logoRemove": "Quitar logo",
      "logoUrlHint": "O pega URL de logo:",
      "typographyLabel": "Tipografía",
      "paletteLabel": "Paleta de colores del evento (Identidad)",
      "paletteHint": "Selecciona una combinación de marca o personaliza el color de acento.",
      "primaryColor": "Color primario",
      "accentColor": "Color acento (botones)",
      "previewBadge": "PRÓXIMO",
      "previewCtaFallback": "Inscribirme"
    },
    "step6": {
      "title": "Revisión y publicación final",
      "description": "Añade información de contacto, tus redes y previsualiza la landing de tu evento antes de guardarlo.",
      "websiteLabel": "Sitio web oficial",
      "emailLabel": "Correo de contacto",
      "mapsLabel": "Enlace Google Maps (Compartir)",
      "socialLabel": "Redes sociales (opcional)",
      "ctaLabel": "Texto del botón de acción (CTA)",
      "ctaPlaceholder": "Ej: Inscribirme al evento",
      "ctaHint": "El texto que aparecerá en el botón principal de reserva de plaza.",
      "reviewBasic": "Básico",
      "reviewLocation": "Ubicación",
      "reviewSpeakers": "Speakers",
      "reviewAgenda": "Agenda",
      "reviewStyle": "Estilo",
      "noTitle": "Sin título",
      "toDefine": "Por definir",
      "speakersCount": "{{count}} ponentes",
      "agendaCount": "{{count}} bloques",
      "visualIdentity": "Identidad visual",
      "withCover": "Con portada",
      "withoutCover": "Sin portada"
    },
    "eventNew": {
      "title": "Crear nuevo evento",
      "subtitle": "Sigue los pasos para publicar tu evento en Biavent. Se guardará como borrador hasta que lo publiques."
    },
    "errors": {
      "fixBeforeContinue": "Corrige los errores antes de continuar al siguiente paso.",
      "loadEvent": "Error al cargar el evento",
      "titleRequiredSave": "Por favor ingresa un título para tu evento",
      "fixStepBeforePublish": "Por favor, corrige los campos del Paso {{step}} antes de publicar.",
      "invalidImage": "Por favor selecciona un archivo de imagen válido (png, jpg, jpeg)",
      "imageTooLarge": "El tamaño de la imagen no puede superar los 5 MB",
      "uploadFailed": "Error al subir la imagen",
      "draftUpdated": "Borrador actualizado correctamente",
      "eventUpdated": "Evento actualizado correctamente",
      "draftSaved": "Borrador guardado. Podrás editarlo y publicarlo más tarde",
      "eventCreated": "¡Enhorabuena! El evento se ha creado correctamente",
      "saveFailed": "Error al guardar"
    },
    "accordion": {
      "advancedLocation": "Ubicación avanzada",
      "capacity": "Aforo y capacidad",
      "contact": "Contacto y redes (opcional)"
    },
    "font": {
      "system": "Sistema (por defecto)",
      "serif": "Serif clásica",
      "modern": "Sans moderna"
    },
    "social": {
      "linkedinPlaceholder": "Enlace LinkedIn de tu empresa",
      "twitterPlaceholder": "Enlace Twitter / X",
      "instagramPlaceholder": "Enlace Instagram"
    }
  },
  "notFound": {
    "title": "Página no encontrada",
    "message": "La página que buscas no existe o ya no está disponible.",
    "goHome": "Ir a eventos",
    "errorTitle": "Página no encontrada",
    "errorMessage": "No pudimos cargar esta vista. Vuelve al inicio o recarga la aplicación.",
    "reload": "Recargar aplicación"
  },
  "meetingQr": {
    "confirmTitle": "Confirmar encuentro",
    "confirmWith": "Con {name}",
    "confirmCta": "Confirmar encuentro",
    "scanCta": "Escanear QR",
    "scanTitle": "Escanear QR de encuentro",
    "scanInstruction": "Apunta la cámara al código QR que muestra la otra persona.",
    "scanHint": "Pide a la otra persona que escanee este QR desde Conexiones → Escanear QR.",
    "generating": "Generando QR seguro…",
    "expiresIn": "Caduca en {time}",
    "confirmed": "¡Encuentro confirmado!",
    "expired": "Este QR ha caducado",
    "generateAgain": "Generar nuevo QR",
    "verifying": "Verificando…",
    "scanAgain": "Escanear de nuevo",
    "back": "Volver",
    "badgeConfirmed": "Encuentro confirmado",
    "errors": {
      "generic": "Algo salió mal. Inténtalo de nuevo.",
      "invalid": "Código QR inválido",
      "expired": "Este QR ha caducado",
      "alreadyUsed": "Este QR ya fue utilizado",
      "notTarget": "Este QR no es para ti",
      "self": "No puedes confirmar un encuentro contigo mismo",
      "noConnection": "Primero debéis estar conectados",
      "alreadyConfirmed": "El encuentro ya está confirmado",
      "noPriorChat": "Debéis haber chateado antes",
      "rateLimited": "Demasiados intentos. Espera un momento.",
      "camera": "No se pudo acceder a la cámara. Revisa los permisos.",
      "cameraDenied": "Permiso de cámara denegado",
      "cameraUnavailable": "No se encontró ninguna cámara en este dispositivo",
      "cameraInsecure": "La cámara requiere una conexión segura (HTTPS)"
    },
    "cameraPermissionTitle": "Se necesita acceso a la cámara",
    "cameraPermissionBody": "Para escanear el QR de encuentro, Biavent necesita usar tu cámara. Pulsa el botón para permitir el acceso.",
    "allowCamera": "Permitir cámara y escanear",
    "requestingCamera": "Solicitando cámara…",
    "cameraDeniedHint": "El acceso a la cámara está bloqueado. Abre los ajustes del navegador o del móvil, permite la cámara para Biavent e inténtalo de nuevo.",
    "tryAgain": "Intentar de nuevo"
  }
}
